<template>
  <div class="footer">
    <b-container fluid>
      <b-row>
        <b-col>
         <!-- {{$session.get('access_key')}}-->
        </b-col>
      </b-row>
    </b-container>
     
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.footer{
  font-size: 10px;
}
</style>
